import React from 'react';
import { HamburgerMenu } from '../components/HamburgerMenu';
import { NewsletterSignup } from '../components/NewsletterSignup';
import { motion } from 'framer-motion';
import { Coffee, Users, Heart, MapPin } from 'lucide-react';
import { SEO } from '../components/SEO';
export function AboutUs() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#D97E3A] selection:text-white" data-id="element-148" data-mp="3ip5rmfezncgg">
      <SEO title="About Grounded - Community Coffee Shop in Livermore" description="Founded in 2023 by Livermore locals, Grounded is a neighborhood coffee shop built on craft coffee, genuine hospitality, and a stronger community — one cup at a time." canonical="https://www.groundedlivermore.com/about" data-id="element-149" data-mp="34pwly9oes0qq" />
      <HamburgerMenu data-id="element-150" data-mp="2zrbmwdkw7n3v" />

      <main data-id="element-151" data-mp="t0lz1ev6csai">
        {/* Hero Section */}
        <section className="relative h-[70vh] w-full overflow-hidden flex items-center justify-center" data-id="element-152" data-mp="t1ncfpznxqve">
          <div className="absolute inset-0 z-0" data-id="element-153" data-mp="xydps5k328d4">
            <img src="https://images.unsplash.com/photo-1442512595367-42736f3e576a?q=80&w=2670&auto=format&fit=crop" alt="Coffee shop interior" className="w-full h-full object-cover opacity-30 grayscale contrast-125" data-id="element-154" data-mp="2fuxl1ugcdwtw" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/40 to-[#0a0a0a]" data-id="element-155" data-mp="2omfyvyptg0jt" />
            <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/concrete-wall.png')] mix-blend-overlay" data-id="element-156" data-mp="2knqqkkjmx971" />
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="relative z-10 text-center px-4" data-id="element-157" data-mp="1rya19vrba8f1">
            <span className="text-[#D97E3A] font-inter font-medium tracking-widest text-sm uppercase mb-4 block" data-id="element-158" data-mp="3hdzp42ktyevb">
              Since 2023
            </span>
            <h1 className="font-bebas text-white leading-[0.85] tracking-tight text-[15vw] lg:text-[10rem]" data-id="element-159" data-mp="2a0757zj3r2lw">
              OUR STORY
            </h1>
          </motion.div>
        </section>

        {/* Content Section */}
        <section className="py-24 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto" data-id="element-160" data-mp="2j0lqiyw2ghpe">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-161" data-mp="2ny410tpqf4zi">
            {/* Left Column - Text */}
            <div className="space-y-12" data-id="element-162" data-mp="1ra7kfouao9oa">
              <motion.div initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} data-id="element-163" data-mp="1vahnasmsijyx">
                <h2 className="font-bebas text-4xl md:text-5xl mb-6 text-[#D97E3A]" data-id="element-164" data-mp="1cjqhu25xbdpt">
                  ROOTED IN LIVERMORE
                </h2>
                <p className="font-inter text-lg text-white/70 leading-relaxed mb-6" data-id="element-165" data-mp="14z66menj8hca">
                  Grounded began with a simple idea: that a coffee shop should
                  be more than just a place to get caffeine. It should be the
                  living room of the neighborhood, a space where connections are
                  made and community is strengthened.
                </p>
                <p className="font-inter text-lg text-white/70 leading-relaxed" data-id="element-166" data-mp="m2enq6bwk48r">
                  Founded in 2023 by Livermore locals, we set out to create a
                  space that reflects the authentic spirit of our town. No
                  pretension, just exceptional coffee served with genuine
                  hospitality.
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: -30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} data-id="element-167" data-mp="3a3pips70ugz">
                <h2 className="font-bebas text-4xl md:text-5xl mb-6 text-[#D97E3A]" data-id="element-168" data-mp="1ome6ep2fkbrb">
                  OUR PHILOSOPHY
                </h2>
                <p className="font-inter text-lg text-white/70 leading-relaxed" data-id="element-169" data-mp="1ept0m1il6wmf">
                  We believe in the power of "slow coffee" in a fast world.
                  Taking the time to source ethically, roast carefully, and brew
                  precisely. But most importantly, taking the time to know our
                  customers by name and drink.
                </p>
              </motion.div>
            </div>

            {/* Right Column - Stats/Values */}
            <div className="space-y-8" data-id="element-170" data-mp="301sypfjp2fg3">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} className="bg-[#111] p-8 border border-white/5 relative overflow-hidden group hover:border-[#D97E3A]/30 transition-colors" data-id="element-171" data-mp="351p6lpviir0x">
                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-172" data-mp="1tlqnjaok53b">
                  <Coffee size={100} data-id="element-173" data-mp="as75b3d16zyt" />
                </div>
                <h3 className="font-bebas text-3xl mb-2" data-id="element-174" data-mp="arnvyb1g5jwe">QUALITY FIRST</h3>
                <p className="font-inter text-white/60" data-id="element-175" data-mp="6s6qvipxmorr">
                  Sourcing only the finest beans from sustainable farms.
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="bg-[#111] p-8 border border-white/5 relative overflow-hidden group hover:border-[#D97E3A]/30 transition-colors" data-id="element-176" data-mp="28iqmp05gxv2i">
                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-177" data-mp="zf9ypp339y2l">
                  <Users size={100} data-id="element-178" data-mp="14600ytg7xkt2" />
                </div>
                <h3 className="font-bebas text-3xl mb-2" data-id="element-179" data-mp="148m7qqvabwa8">COMMUNITY DRIVEN</h3>
                <p className="font-inter text-white/60" data-id="element-180" data-mp="194l2qxb4ccjm">
                  Hosting local events, art shows, and gatherings.
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="bg-[#111] p-8 border border-white/5 relative overflow-hidden group hover:border-[#D97E3A]/30 transition-colors" data-id="element-181" data-mp="1i72qxhac3f99">
                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-182" data-mp="3hcg8rjvw1jzv">
                  <Heart size={100} data-id="element-183" data-mp="3cl7wmg36bkj0" />
                </div>
                <h3 className="font-bebas text-3xl mb-2" data-id="element-184" data-mp="37n6bzqq3nd5f">LOCALLY OWNED</h3>
                <p className="font-inter text-white/60" data-id="element-185" data-mp="37l2bzjvbmyaf">
                  Built by neighbors, for neighbors.
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Team/Values Grid */}
        <section className="py-24 bg-[#111] border-y border-white/5" data-id="element-186" data-mp="38nr2t958ajhb">
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24" data-id="element-187" data-mp="38mfzfafp3dqq">
            <div className="text-center mb-16" data-id="element-188" data-mp="3dgk5lrh4zhqr">
              <h2 className="font-bebas text-5xl md:text-7xl mb-4" data-id="element-189" data-mp="2znulxtp2yowt">
                THE <span className="text-[#D97E3A]" data-id="element-190" data-mp="2zlhvst96588o">TEAM</span>
              </h2>
              <p className="font-inter text-white/60 max-w-2xl mx-auto" data-id="element-191" data-mp="33pphehkby82o">
                Passionate baristas, skilled roasters, and community builders.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-192" data-mp="763kk2ef4re">
              {[1, 2, 3].map(i => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="group relative aspect-[3/4] overflow-hidden bg-[#0a0a0a]" data-id="element-193" data-mp="3idkba1a2qihc">
                  <img src={`https://images.unsplash.com/photo-${i === 1 ? '1583336130106-780658299015' : i === 2 ? '1512485694743-9c9538b4e6e0' : '1507914372817-940811243d44'}?q=80&w=800&auto=format&fit=crop`} alt="Team member" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-194" data-mp="2dfp5a5mcdh87" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent opacity-80" data-id="element-195" data-mp="1ugkyl3i9vzjp" />
                  <div className="absolute bottom-0 left-0 p-6" data-id="element-196" data-mp="1pot80sz49ttk">
                    <h3 className="font-bebas text-2xl text-white" data-id="element-197" data-mp="11zgwhmgbh9o3">
                      TEAM MEMBER {i}
                    </h3>
                    <p className="font-inter text-sm text-[#D97E3A]" data-id="element-198" data-mp="x04a12tcy4m1">Barista</p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </section>

        <NewsletterSignup data-id="element-199" data-mp="1nmnmkfdoxo9d" />

        {/* Footer */}
        <footer className="border-t border-white/10 py-12 text-center bg-[#0a0a0a]" data-id="element-200" data-mp="1im9g31rqmmdg">
          <p className="font-bebas text-2xl text-white/50" data-id="element-201" data-mp="1io2mqh2cp6lg">
            © {new Date().getFullYear()} GROUNDED LIVERMORE
          </p>
        </footer>
      </main>
    </div>;
}